export const ProjectData = [
    {
        id: 3,
        title: "ETHEREUM TOKEN (ERC-20)",
        about:"It's a personalised currency on the Ethereum blockchain.It is named as GP. and is built with Ethereum’s native programming language Solidity. It has the ability to create, destroy and transfer coins between the users.",
        tags: ["Solidity"],
        // demo: "https://roamaroundearth.netlify.app/ ",
        github: "https://github.com/vishnugprasad/EthereumERC20-GP",
        image: require("../../assets/token.png")
       
    },
    {
        id: 1,
        title: " OFFICE SEATBOOKING",
        about:"The project is a generalized platform focused on creating and managing real time seatbooking in the office , where an employee can choose to book his/her seat in advance by checking the availability. The aim was to make the hybrid work model more friendly to the employees . The front end of the application is developed with React and backend with node.js. This is deployed in Netlify",
        tags: ["Reactjs", "Nodejs", "JavaScript","CSS"],
        demo: "https://seatbookinghours.netlify.app/ ",
        github: "https://github.com/vishnugprasad/Hours-subsidary-",
        image: require("../../assets/hours.png")
       
    },
    {
        id: 2,
        title: " ROAM AROUND EARTH",
        about:"This is the landing page of a new upcoming travel app. The website is built with an interactive UI which explains the features of the app.. The inclusion of a peak window and the usage of intersection observer api has made the website more attractive.",
        tags: ["Reactjs", "JavaScript", "CSS"],
        demo: "https://roamaroundearth.netlify.app/ ",
        github: "https://github.com/vishnugprasad/traveltime",
        image: require("../../assets/traveltime.png")
       
    }
]